import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';
import Image from '@/components/route/blog/BlogPostImage/Image';
import Heading from '@/components/switchback/Heading/Heading';
import Link from '@/components/switchback/Link/Link';
import { IBlogPost } from '@/services/types/blog/post.types';

import css from './BlogPostCard.module.css';

interface IPost {
  post: IBlogPost;
  ratio?: string;
}

const BlogPostCard: React.FC<IPost> = ({
  post: { images, title, slug, categories },
  ratio = '8:5',
}) => {
  return (
    <>
      <Link legacy href="/blog/[blogPostSlug]" as={`/blog/${slug}`}>
        <a href={`/blog/${slug}`}>
          <div className="relative h-full overflow-hidden rounded">
            <AspectRatio ratio={ratio} hasImageHover={false} className="h-full">
              <Image images={images} title={title || ''} />
            </AspectRatio>
            <div className="absolute bottom-0 left-0 content-end w-full p-3 text-white grid lg:p-4 lg:pt-8 bg-gradient-to-t from-gray-900">
              <p
                className="uppercase text autoType300"
                // @ts-expect-error fixable: unchecked index access
                dangerouslySetInnerHTML={{ __html: categories[0].name }}
              />
              {!!title && (
                <Heading
                  level={3}
                  className={`highlight text-600 h-13 leading-6 text-white ${css.clamp2}`}>
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </Heading>
              )}
            </div>
          </div>
        </a>
      </Link>
    </>
  );
};

export default BlogPostCard;
